function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaRegFilePdf, FaRegFileWord } from "react-icons/fa";
import i18n from "../../utils/i18n/i18n";
import { FormikButton } from "../button";
import Dropdown from "../dropdown";
var GenerateProposalDropdown = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(GenerateProposalDropdown, Component);
    var _super = _createSuper(GenerateProposalDropdown);
    function GenerateProposalDropdown() {
        _classCallCheck(this, GenerateProposalDropdown);
        return _super.apply(this, arguments);
    }
    var _proto = GenerateProposalDropdown.prototype;
    _proto.render = function render() {
        var _props = this.props, theme = _props.theme, _options = _props.options, asPdf = _options.asPdf, asDoc = _options.asDoc, asDraft = _options.asDraft, isLoggedIn = _props.isLoggedIn, onChange = _props.onChange, disabled = _props.disabled, children = _props.children;
        return /*#__PURE__*/ React.createElement(Dropdown, null, function(param) {
            var DropdownTrigger = param.DropdownTrigger, DropdownList = param.DropdownList;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DropdownTrigger, null, /*#__PURE__*/ React.createElement(FormikButton, {
                "data-testid": "document-edit-submit-button",
                fullWidth: true,
                primary: true,
                type: "button",
                disabled: disabled
            }, i18n("proposalGeneration.generateProposal"), /*#__PURE__*/ React.createElement(IoMdArrowDropdown, {
                size: 20
            }))), /*#__PURE__*/ React.createElement(DropdownList, null, /*#__PURE__*/ React.createElement("ul", null, children, asPdf && /*#__PURE__*/ React.createElement("li", {
                onClick: function() {
                    onChange("asQuotePdf");
                }
            }, /*#__PURE__*/ React.createElement(FormikButton, {
                "data-testid": "document-edit-asPdf-button",
                fullWidth: true,
                primary: false,
                type: "submit"
            }, i18n("proposalGeneration.asAPdf"), /*#__PURE__*/ React.createElement(FaRegFilePdf, {
                size: 20,
                color: theme
            }))), asDoc && /*#__PURE__*/ React.createElement("li", {
                onClick: function() {
                    onChange("asQuoteWord");
                }
            }, /*#__PURE__*/ React.createElement(FormikButton, {
                "data-testid": "document-edit-asWord-button",
                fullWidth: true,
                primary: false,
                type: "submit"
            }, i18n("proposalGeneration.asAWord"), /*#__PURE__*/ React.createElement(FaRegFileWord, {
                size: 20,
                color: theme
            }))), asDraft && isLoggedIn && /*#__PURE__*/ React.createElement("li", {
                onClick: function() {
                    onChange("asDraft");
                }
            }, /*#__PURE__*/ React.createElement(FormikButton, {
                "data-testid": "document-edit-asDraft-button",
                fullWidth: true,
                primary: false,
                type: "submit"
            }, i18n("proposalGeneration.saveForLater"))))));
        });
    };
    return GenerateProposalDropdown;
}(Component);
export default GenerateProposalDropdown;
